import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "text" }

interface Props{
  info:any
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ItemContent',
  props: {
    info: { default: ()=>{
    return {
      img:'',
      name:''
    }
  } }
  },
  setup(__props: any) {

const props=__props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      src: _ctx.info.img,
      mode: "widthFix"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.info.name), 1)
  ]))
}
}

})